<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">审批</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>提现审批</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <el-tabs :value="activeTab" @tab-click="handleTabChange">
        <el-tab-pane label="已提交" name="1"></el-tab-pane>
        <el-tab-pane label="已审核" name="4"></el-tab-pane>
        <el-tab-pane label="区块链网络已经发送，等待确认中" name="5"></el-tab-pane>
        <el-tab-pane label="提现成功" name="0"></el-tab-pane>
        <el-tab-pane label="失败" name="-1"></el-tab-pane>
        <el-tab-pane label="已取消" name="2"></el-tab-pane>
        <el-tab-pane label="系统异常" name="6"></el-tab-pane>
        <el-tab-pane label="管理员撤销" name="7"></el-tab-pane>
      </el-tabs>
      <div class="page-actions">
        <el-select v-model="nowCoin" placeholder="请选择币种" clearable>
          <!-- <el-option label="所有币种" value=""></el-option> -->
          <el-option v-for="coin in chooseData" :label="coin" :value="coin" :key="coin"></el-option>
        </el-select>
        <el-select v-model="nowChain" placeholder="请筛选币种链" clearable>
          <!-- <el-option label="所有币种" value=""></el-option> -->
          <el-option v-for="coin in chainsOptions" :label="coin" :value="coin" :key="coin"></el-option>
        </el-select>
        <el-select v-model="queryType" placeholder="请选择用户类型">
          <el-option v-for="item in queryTypeList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="txType" placeholder="请选择提现类型">
          <el-option v-for="item in txTypeList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-input placeholder="请输入内容" v-model="queryValue" clearable></el-input>
        <el-input placeholder="请输入邮箱" v-model="email" clearable></el-input>
        <!-- <el-input placeholder="请输入邮箱" v-model="email" clearable></el-input> -->
        <el-input placeholder="请输入订单号" v-model="id" clearable></el-input>
        <el-input placeholder="请输入提现地址" v-model="walletAddres" clearable style="width: 340px;">
        </el-input>
        <el-input placeholder="hash" v-model="hashCode"> </el-input>
        <el-select v-model="mark" placeholder="请筛选异常账户" clearable>
          <!-- <el-option>全部</el-option> -->
          <el-option v-for="item in ifMark" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-date-picker v-model="times" type="daterange" format="yyyy 年 MM 月 dd 日" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp">
        </el-date-picker>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
        <el-button @click="exportData" target="_blank">导出Excel</el-button>
        <el-button type="success" v-if="activeTab == '1'" @click="handleBatchAudit">批量审核</el-button>
        <!-- <a :href="downloadLink"  target="_blank">导出Excel</a> -->
      </div>
      <audit-list @refresh="getList" :activeTab="activeTab"></audit-list>
    </el-card>
    <el-dialog title="批量审核" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">

        <el-form-item label="谷歌验证码" prop="googleCode">
          <el-input v-model="form.googleCode"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="BatchSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import './store';
import AuditList from './components/list';
import qs from 'qs';
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';

export default {
  name: 'WithdrawalAudit',
  data() {
    return {
      form: {},
      dialogVisible: false,
      times: [],
      // startTime:'',
      // endTime:'',
      // chainsOptions:[],
      id: '',
      email: '',
      phone: '',
      nowChain: '',
      nowCoin: '',
      walletAddres: '',
      queryValue: '',
      queryType: '',
      txType: '',
      hashCode: '',
      mark: null,
      rules: {
        googleCode: [{ required: true, message: '请填写谷歌验证码', trigger: blur }],

      },
      queryTypeList: [
        {
          value: '0',
          label: '用户ID'
        },
        {
          value: '1',
          label: '用户账号'
        }
      ],
      txTypeList: [
        { value: -1, label: '提现' },
        { value: -2, label: '内部转账' }
      ],
      ifMark: [
        { value: true, label: '异常账户' },
        { value: false, label: '非异常账户' }
      ]
    };
  },
  components: {
    AuditList
  },
  computed: {
    ...mapState('withdrawalAudit', ['activeTab', 'allCoins', 'chooseData', 'pagination', 'chainsData', 'idStr']),
    // ...mapGetters('withdrawalAudit',['allCoins']),
    chainsOptions() {
      return ([...new Set([...this.chainsData, ...this.chooseData])])

    },

    startTime() {
      return this.times ? this.times[0] : '';
    },
    endTime() {
      return this.times ? this.times[1] : '';
    },
    downloadLink() {
      const data = {
        txStatus: this.activeTab,
        nowCoin: this.nowCoin,
        walletAddres: this.walletAddres,
        queryValue: this.queryValue,
        queryType: this.queryType,
        startTime: this.startTime,
        endTime: this.endTime,
        hashCode: this.hashCode,
        status: 1,
        txType: this.txType,
        ...this.pagination
      };
      const params = qs.stringify(data);
      return `/la/admin/workorder/search_withdraw?${params}`;
    }
  },
  methods: {
    ...mapMutations('withdrawalAudit', ['changeTab']),
    ...mapActions('withdrawalAudit', [
      'list',
      'listCoinType',
      'listBillType',
      'getAllCoins',
      'changeCoinType', 'getChooseData', 'getChains', 'getExcelData', 'batchApproveAudit'
    ]),
    exportData() {
      const data = {
        txStatus: this.activeTab,
        nowCoin: this.nowCoin,
        walletAddres: this.walletAddres,
        queryValue: this.queryValue,
        queryType: this.queryType,
        startTime: this.startTime,
        endTime: this.endTime,
        hashCode: this.hashCode,
        status: 1,
        txType: this.txType,
        ...this.pagination
      };
      const params = qs.stringify(data);
      this.getExcelData(params).then(res => {
        const link = document.createElement('a')
        const blob = new Blob([res], { type: 'application/vnd.ms-excel' }) //设置文件流
        link.style.display = 'none'
        // 设置连接
        link.href = URL.createObjectURL(blob)  //将文件流转化为blob地址
        console.log('link-href', link.href);
        link.download = '提现审批统计报表'
        document.body.appendChild(link)
        // 模拟点击事件
        link.click()  //设置点击事件

      })
    },

    handleTabChange(tab) {
      this.changeTab(tab.name);
      this.getList({
        page: 1
      });
    },
    getList(data = {}) {
      this.list({
        chain: this.nowChain,
        userId: this.userId,
        txStatus: this.activeTab,
        walletAddres: this.walletAddres,
        email: this.email,
        phone: this.phone,
        id: this.id,
        txType: this.txType,
        ...this.pagination,
        ...data
      });
    },
    //批量审核
    handleBatchAudit() {
      this.dialogVisible = true
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    BatchSubmit() {
      console.log(12345, this.form);
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.batchApproveAudit({ id: this.idStr, googleCode: this.form.googleCode }).then(res => {
            if (res.code == 0) {
              this.dialogVisible = false
              this.form = {}
              this.$message({
                message: '操作成功！',
                type: 'success'
              });
              this.handleSearch()
              this.$refs.form.resetFields();
            }
          })
        }
      })
    },
    handleSearch() {
      this.getList({
        page: 1,
        coinType: this.nowCoin,
        walletAddres: this.walletAddres,
        queryValue: this.queryValue,
        email: this.email,
        phone: this.phone,
        id: this.id,
        queryType: this.queryType,
        hashCode: this.hashCode,
        mark: this.mark,
        startTime: this.startTime,
        endTime: this.endTime,
        txType: this.txType
      });
    }
  },
  watch: {
    nowCoin(val) {
      this.changeCoinType(val);
      this.getList({
        page: 1,
        coinType: val
      });
    },
    // times(val,oldVal){

    // }

  },
  mounted() {
    //  this.chainsOptions=[...this.chainsData,...this.chooseData]

  },
  created() {
    this.getAllCoins();
    this.getList();
    this.getChooseData()
    this.getChains()
  }
};
</script>

<style lang="less">
.user-withdrawal-link {
  color: #409eff;

  .cell {
    span {
      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.user-withdrawal-records-wrap {
  .el-table {
    .cell {
      font-size: 12px;
      text-align: center;
    }
  }

  .user-withdrawal-pager-wrap {
    text-align: right;
    margin: 10px 0px;
  }
}
</style>
